import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useAuth } from "@/features/auth/AuthProvider";
import type { StreakState } from "@/types/menu";

const FALLBACK: StreakState = {
  current_streak: 0,
  longest_streak: 0,
  last_validated_week: null,
};

export function useStreak(): {
  data: StreakState;
  isLoading: boolean;
} {
  const { session, configured } = useAuth();
  const enabled = configured && Boolean(session);

  const query = useQuery<StreakState>({
    queryKey: ["streak", session?.user.id],
    queryFn: () => api<StreakState>("/api/v1/me/streak"),
    enabled,
    staleTime: 60_000,
  });

  return {
    data: query.data ?? FALLBACK,
    isLoading: enabled && query.isLoading,
  };
}
